
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import i18n from '../i18n';

export default function LanguageInitializer() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    // Check for language in URL params
    const params = new URLSearchParams(location.search);
    const lang = params.get("lang");
    
    if (lang && ['en', 'vi'].includes(lang) && i18n.language !== lang) {
      // Update language if parameter exists and is valid
      i18n.changeLanguage(lang);
    } else if (!lang && i18n.language !== 'vi') {
      // If no lang parameter and current language is not Vietnamese,
      // add vi parameter to URL
      params.set('lang', 'vi');
      navigate({
        pathname: location.pathname,
        search: params.toString()
      }, { replace: true });
    }
  }, [location, navigate]);

  return null;
}

